import { render, staticRenderFns } from "./PharmacyUioComponent.vue?vue&type=template&id=09577e9e"
import script from "./PharmacyUioComponent.vue?vue&type=script&lang=js"
export * from "./PharmacyUioComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports